import { useState } from 'react';

export default function FinalCTA() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6airgfmvg9ih2c7aks0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', company: '', phone: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="relative bg-gradient-to-br from-[#0A1628] to-[#2D1B4E] py-40 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-blue-600/20 rounded-full blur-3xl"></div>

      <div className="relative max-w-[900px] mx-auto px-20 text-center">
        <span className="text-xs font-semibold text-gray-400 uppercase tracking-[0.15em] mb-6 block">Ready to Modernize</span>
        <h2 className="text-6xl font-bold text-white mb-8 leading-tight" style={{ fontFamily: 'Crimson Pro, serif' }}>
          Apply intelligence where it matters most
        </h2>
        <p className="text-xl text-white/80 mb-14 max-w-[700px] mx-auto">
          If your firm is ready to modernize—without compromising credibility—GenieAiX is your systems partner.
        </p>

        <form 
          id="strategy-call-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="bg-white/10 backdrop-blur-md rounded-3xl p-12 max-w-[600px] mx-auto"
        >
          <div className="space-y-5 mb-8">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              required
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="w-full px-6 py-4 bg-white/10 border-2 border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-white/40 transition-colors text-sm"
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="w-full px-6 py-4 bg-white/10 border-2 border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-white/40 transition-colors text-sm"
            />
            <input
              type="text"
              name="company"
              placeholder="Company Name"
              required
              value={formData.company}
              onChange={(e) => setFormData({ ...formData, company: e.target.value })}
              className="w-full px-6 py-4 bg-white/10 border-2 border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-white/40 transition-colors text-sm"
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              className="w-full px-6 py-4 bg-white/10 border-2 border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-white/40 transition-colors text-sm"
            />
            <textarea
              name="message"
              placeholder="Tell us about your needs"
              rows={4}
              maxLength={500}
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              className="w-full px-6 py-4 bg-white/10 border-2 border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-white/40 transition-colors resize-none text-sm"
            ></textarea>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full py-5 bg-white text-gray-900 text-base font-bold rounded-lg hover:bg-gray-100 transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? (
              'Sending...'
            ) : (
              <>
                <i className="ri-calendar-line text-xl"></i>
                Book a Strategy Call
              </>
            )}
          </button>

          {submitStatus === 'success' && (
            <div className="mt-4 p-4 bg-green-500/20 border border-green-500/30 rounded-lg">
              <p className="text-white text-sm">Thank you! We'll be in touch soon.</p>
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="mt-4 p-4 bg-red-500/20 border border-red-500/30 rounded-lg">
              <p className="text-white text-sm">Something went wrong. Please try again.</p>
            </div>
          )}

          <p className="text-white/60 text-sm mt-6">
            or <a href="#approach" className="text-white hover:underline cursor-pointer">explore our approach</a>
          </p>
        </form>
      </div>
    </section>
  );
}
